const fileSize = (byteSize: number | undefined) => {
  if (!byteSize) {
    return '';
  }
  const kb = byteSize / 1000;
  if (kb < 1000) {
    return `${kb.toFixed(2)} kB`;
  }
  const mb = kb / 1000;
  if (mb < 1000) {
    return `${mb.toFixed(2)} MB`;
  }
};

export default fileSize;
